import service = require("./breeze.entityManager.service");
import base = require("./base.dataservice");
import { Injectable, Inject } from '@angular/core';

export function initialize(module: ng.IModule) {
    module.service(CompetenceGroupsService.Id, CompetenceGroupsService);

    CompetenceGroupsService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class CompetenceGroupsService extends base.BaseDataService<Nema.Crew.Model.CompetenceGroup> implements ICompetenceGroupsService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "competenceGroupsService";

    protected get EntityName(): string {
        return "CompetenceGroup";
    }

    protected get EntitiesName(): string {
        return "CompetenceGroups";
    }
}

export interface ICompetenceGroupsService extends base.IDataService<Nema.Crew.Model.CompetenceGroup> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/competencegroups.dataservice.ts